export const ie11ReadOnlyClickHandler = (event) => event.currentTarget && event.currentTarget.blur();
